import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const AppService = httpFactory({ baseURL: configurationURL.dashboard.baseUrl + '/api/apps' });

export const getAppList = params => AppService.get('', { params }).then(response => response?.data?.apps || []);

export const getAppListWithAccessDetails = ({ access, ...params }) =>
  getAppList({ ...params }).then(response => {
    const appList = response;

    if (!access) {
      return appList;
    }

    return appList
      .map(app => {
        const accessDetail = access.find(accessDetail => accessDetail.token === app.token);

        if (accessDetail) {
          app.access = accessDetail;
        }

        return app;
      })
      .sort((a, b) => {
        if (a.access && !b.access) {
          return -1;
        } else if (b.access && !a.access) {
          return 1;
        }

        return a.name.localeCompare(b.name);
      });
  });
